import { useQuery } from "react-query";
import { pages } from "@/services/common.request";
import { IPricing } from "@/types/billing.types";
import { DEBUGGER } from "@/helper/helper";
import { useUserState } from "@/states/user.state";

const usePricing = (initialData?: IPricing) => {
  const { guestToken } = useUserState.getState();
  const { data, isLoading, isFetching, isRefetching, isSuccess } = useQuery(
    ["PRICING", guestToken],
    pages.getPricing,
    {
      initialData,
      onError: (error: unknown) => {
        DEBUGGER("Error fetching pricing usePricing => ", error);
      },
      enabled: Boolean(guestToken),
    },
  );

  return {
    data,
    isLoading,
    isFetching,
    isRefetching,
    isSuccess,
  };
};

export default usePricing;
